import * as React from 'react';
import * as styles from './Highlighter.css';

export const Highlighter: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <span className={styles['text']}>{children}</span>;
};
